//export const baseurl = 'http://localhost:8088'
//export const baseurl = 'https://adminapi.mysticone.io' 
export const baseurl = 'https://adminapi.lucyomni.com' 
export const defaultPicture = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
